import { RegisterDocument } from './RegisterDocument'

export default RegisterDocument
